export const yesNoOptions = [
    { label: 'Yes', value: true },
    { label: 'No', value: false },
]

export const yesNoOptionsNum = [
    { label: 'Yes', value: 1 },
    { label: 'No', value: 0 },
]

export const yesNoOptionsString = [
    { label: 'Yes', value: 'Yes' },
    { label: 'No', value: 'No' },
]

export const filterOptions = [
    { label: 'All', value: '' },
    { label: 'Active', value: 'active' },
    { label: 'Inactive', value: 'inactive' },
]

export const serviceTypeOptions = [
    { label: 'REPAIR', value: 'REPAIR' },
    { label: 'MAINTENANCE', value: 'MAINTENANCE' },
    { label: 'INSPECTION', value: 'INSPECTION' },
    { label: 'OTHER', value: 'OTHER' },
]

export const scheduleOptions = [
    { label: 'Weekly', value: 'Weekly' },
    { label: 'Monthly', value: 'Monthly' },
    { label: 'Quarterly', value: 'Quarterly' },
    { label: 'Half-Yearly', value: 'Half-Yearly' },
    { label: 'Yearly', value: 'Yearly' },
]

export const eventTypeOptions = [
    { label: 'Online', value: 'Online' },
    { label: 'Offline', value: 'Offline' },
]

export const eventStatusOptions = [
    { label: 'Open', value: 'Open' },
    { label: 'Closed', value: 'Closed' },
]

export const recommendationTypeOptions = [
    { label: 'Schedule Maintenance', value: 'Schedule Maintenance' },
    { label: 'Usage Tips', value: 'Usage Tips' },
    { label: 'Part Replacement', value: 'Part Replacement' },
    { label: 'Warranty Extension', value: 'Warranty Extension' },
]

export const reminderTypeOptions = [
    { label: 'General Service', value: 'General Service' },
    { label: 'Specific Maintenance', value: 'Specific Maintenance' },
    { label: 'Part Replacement', value: 'Part Replacement' },
    { label: 'Warranty Ended', value: 'Warranty Ended' },
    { label: 'Other', value: 'Other' },
]

export const faqTypeOptions = [
    { label: 'Product Advice', value: 'PRODUCT_ADVICE' },
    { label: 'Product Information', value: 'PRODUCT_INFORMATION' },
    { label: 'Product Care', value: 'PRODUCT_CARE' },
    { label: 'FAQ', value: 'FAQ' },
    { label: 'Warranty Exclusion', value: 'WARRANTY_EXCLUSION' },
]

export const lengthOption = [
    {
        id: 10,
        label: 10,
    },
    {
        id: 25,
        label: 25,
    },
    {
        id: 50,
        label: 50,
    },
    {
        id: 100,
        label: 100,
    },
]

export const ProductFromOptions = [
    { label: 'By Individual', value: 'individual' },
    { label: 'By Business', value: 'business' },
    { label: 'By Admin', value: 'admin' },
    { label: 'By User', value: 'user' },
    { label: 'By Invite', value: 'invite' },
    { label: 'Other', value: 'other' },
]

export const ComponentFilterOptions = [
    { label: 'Product', value: false },
    { label: 'Component', value: true },
]

export const CompanyTypeOptions = [
    { label: 'All', value: 'all' },
    { label: 'Register', value: 'permanent' },
    { label: 'Not Register', value: 'temporary' },
]
